import { Swiper, Pagination, Navigation } from 'swiper';

Swiper.use([Pagination, Navigation]);

Drupal.behaviors.ImageSwiper = {
  attach(context) {
    const swiper = new Swiper('.image-swiper .image-swiper-container', {
      direction: 'horizontal',
      loop: true,
      observer: true,
      spaceBetween: 10,
      centeredSlidesBounds: true,
      centeredSlides: true,
      a11y: true,
      observeParents: true,
      slidesPerView: 1.08,
      keyboardControl: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  },
};
